module.exports = __webpack_public_path__ + "static/media/kumhoPetro.46fe480e.png";